const CLIENT_ID_KEY = 'memoir44_client_id';

/** Persistent anonymous per-browser ID, used to identify this browser's games/tournaments across sessions. */
export function getClientId(): string {
  let id = localStorage.getItem(CLIENT_ID_KEY);
  if (!id) {
    id = crypto.randomUUID?.() ?? `c-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(CLIENT_ID_KEY, id);
  }
  return id;
}
